import request from "@/utils/request";

// 新增运营商
export function reqAddMctApi(data) {
  return request({
    url: "/org_mct/v1",
    method: "POST",
    data,
  });
}

// 运营商费率管理
export function reqGetMctRateListApi(data) {
  return request({
    url: "/cabinet_payment/v1",
    method: "POST",
    data,
  });
}

// 费率导出
export function reqExporttMctRateListApi(data) {
  return request({
    url: "/export/cabinet_payment/v1",
    method: "POST",
    data,
  });
}

// 运营商费率详情
export function reqGetMctRateApi(id) {
  return request({
    url: `/cabinet_payment/${id}/v1`,
    method: "GET",
  });
}

// 修改费率
export function reqEditMctRateApi(data) {
  return request({
    url: `/cabinet_payment/batch/v1`,
    method: "PUT",
    data,
  });
}

// 查看模板
export function reqGetMctRateTemplateApi(id) {
  return request({
    url: `/mct_shop/template/${id}/v1`,
    method: "GET",
  });
}

// 编辑运营商
export function reqEditMctApi(id, data) {
  return request({
    url: `/mct/${id}/v1`,
    method: "PUT",
    data,
  });
}

// 查看运营商pay
export function reqGetMctPayApi(id) {
  return request({
    url: `/mct/payment/${id}/v1`,
    method: "GET",
  });
}

// 获取运营商列表
export function reqGetMctListApi(params) {
  return request({
    url: "/mct/v1",
    params,
  });
}

// 获取商户详情
export function reqGetMctDetailApi(id) {
  return request({
    url: `/mct/${id}/v1`,
    method: "GET",
  });
}

// 启用禁用商户
export function reqEnableMctApi(id) {
  return request({
    url: `/org_mct/enabled/${id}/v1`,
    method: "PUT",
  });
}

// 重置密码
export function reqResetMctApi(id) {
  return request({
    url: `/mct/${id}/reset/v1`,
    method: "PUT",
  });
}

// 登录商户后台
export function reqLoginMctApi(params) {
  return request({
    url: "/org_mct/encryption/v1",
    params,
  });
}

// 查看商户菜单权限
export function reqGetMctMenuApi(params) {
  return request({
    url: "/org_mct/module_list",
    params,
  });
}

// 查看商户商品列表
export function reqGetMctGoodsApi(id, params) {
  return request({
    url: `/org_mct/goods_list/${id}`,
    params,
  });
}

/* 
运营商品库
*/
// 当前商品列表
export function reqGetMctGoodsListApi(params) {
  return request({
    url: "/org_goods/v1",
    params,
  });
}

// 添加商品列表
export function reqAddMctGoodsApi(params) {
  return request({
    url: "/org_goods/firm_worker_level/goods_list",
    params,
  });
}

// 移除或恢复
export function reqRemoveMctGoodsApi(id) {
  return request({
    url: `/org_goods/update/${id}`,
    method: "PUT",
  });
}

// 添加至我的商品库
export function reqAddMctGoodsToMyApi(data) {
  return request({
    url: "/org_goods/v1",
    method: "POST",
    data,
  });
}

/* 
服务管控列表
*/
// 列表
export function reqGetMctServiceListApi(params) {
  return request({
    url: "/org_mct_module/v1",
    params,
  });
}
// 编辑时所有权限列表
export function reqGetMctServiceAllApi(params) {
  return request({
    url: "/org_mct_module/firm_worker_level/module_list",
    params,
  });
}
// 编辑权限
export function reqEditMctServiceApi(data) {
  return request({
    url: `/org_mct_module/update_org`,
    method: "PUT",
    data,
  });
}

/* 
运营商管理
*/
// 列表
export function reqGetMctOperatorListApi(params) {
  return request({
    url: "/org_mct/v1",
    params,
  });
}

// 编辑
export function reqEditMctOperatorApi(id, data) {
  return request({
    url: `/org_mct/${id}/v1`,
    method: "PUT",
    data,
  });
}

// 新增
export function reqAddMctOperatorApi(data) {
  return request({
    url: "/org_mct/v1",
    method: "POST",
    data,
  });
}

// 启用禁用商户
export function reqEnableMctOperatorApi(id) {
  return request({
    url: `/org_mct/enabled/${id}/v1`,
    method: "PUT",
  });
}

// 重置密码
export function reqResetMctOperatorApi(id) {
  return request({
    url: `/org_mct/${id}/reset/v1`,
    method: "PUT",
  });
}

// 登录商户后台
export function reqLoginMctOperatorApi(params) {
  return request({
    url: "/org_mct/encryption/v1",
    params,
  });
}

// 查看商户菜单权限
export function reqGetMctOperatorMenuApi(params) {
  return request({
    url: "/org_mct/module_list",
    params,
  });
}

// 查看商户商品列表
export function reqGetMctOperatorGoodsApi(id, params) {
  return request({
    url: `/org_mct/goods_list/${id}`,
    params,
  });
}

// 查看商户货柜列表
export function reqGetMctOperatorCabinetApi(id, params) {
  return request({
    url: `/org_mct/cab_code/${id}/list`,
    params,
  });
}

// 查看商户商品列表 - 启用/禁用
export function reqEnableMctOperatorGoodsApi(id) {
  return request({
    url: `/org_mct/update/${id}`,
    method: "PUT",
  });
}

// 组织列表
export function orgList(params) {
  return request({
    url: "/firm_org/v1",
    params,
  });
}

// 更换组织
export function changeMctOrgApi(id, data) {
  return request({
    url: `/org_mct/change_org/${id}/v1`,
    method: "PUT",
    data,
  });
}
// 公司名称列表
export function getCompanyList(params) {
  return request({
    url: "/mct_corporation/v1",
    params,
  });
}
export function addMerchant(data) {
  return request(
    {
      url: "/mct/v1",
      method: "POST",
      data,
    },
    {
      success: true,
      successMsg: "新增成功",
    }
  );
}

// 修改商户
export function eidtMerchant(id, data) {
  return request(
    {
      url: `/mct/${id}/v1`,
      method: "PUT",
      data,
    },
    {
      success: true,
      successMsg: "修改成功",
    }
  );
}

// 商户详情
export function getMerchant(id) {
  return request({
    url: `/mct/${id}/v1`,
  });
}
// 经营列表
export function getRegionApi(params) {
  return request({
    url: `/mct/region/v1`,
    params,
  });
}

// 美国洲列表
export function getUsaList(data) {
  return request({
    url: `/mct/states/v1`,
    method: "POST",
    data,
  })
}

// 经销商列表
export function firmListApi(params) {
  return request({
    url: `/firm/v1`,
    params,
  });
}
// 经销商启用禁用
export function firmEnableApi(params) {
  return request({
    url: `/firm/enabled/${params.id}/v1`,
    params,
  });
}
// 经销商重置密码
export function firmResetPasswordApi(id) {
  return request({
    url: `/firm/${id}/reset/v1`,
    method: "PUT",
  });
}
// 经销商新增
export function addFirmApi(data) {
  return request({
    url: `/firm/v1`,
    method: "POST",
    data
  });
}
// 经销商详情
export function firmDetailApi(id){
  return request({
    url: `/firm/${id}/v1`,
  });
}
// 经销商修改
export function editFirmApi(id,data) {
  return request({
    url: `/firm/${id}/v1`,
    method: "PUT",
    data
  });
}
// 经销商下拉列表
export function frimSelectApi(params){
  return request({
    url: '/firm/v1',
    params
  });
}
// 经销商组织下拉
export function getFirmTreeList(params) {
  return request({
    url: `/firm/selected/v1`,
    params
  })
}
// 商户管理启用禁用
export function mctEnableApi(data) {
  return request({
    url: `/mct/enabled/${data.id}/v1`,
    method:"PUT",
    data
  })
}

// 代收进件新增
export function addCollectionApi(data) {
  return request({
    url: `/mct/register/collection/v1`,
    method: "POST",
    data
  });
}

// 进件列表
export function getCollectionListApi(params) {
  return request({
    url: `/mct/register/v1`,
    params
  });
}

// 进件详情
// export function getCollectionDetailApi(id) {
//   return request({
//     url: `/mct/register/${id}/v1`,
//   });
// }

// Pax进件新增
export function addPaxApi(data) {
  return request({
    url: `/mct/register/pax/v1`,
    method: "POST",
    data
  });
}

// 进件编辑
export function editCollectionApi(id, data) {
  return request({
    url: `/mct/register/${id}/v1`,
    method: "PUT",
    data
  });
}

// 进件修改状态
export function editCollectionStatusApi(id, data) {
  return request({
    url: `/mct/register/${id}/v1`,
    method: "PUT",
    data
  });
}

// 查看是否有进件过
export function getCollectionApi() {
  return request({
    url: `/register/v1`,
  });
}

// 查看进件详情
export function getCollectionDetailApi(params) {
  return request({
    url: `/register/details/v1`,
    params
  });
}

// Pax新增进件
export function addPaxApiNew(data) {
  return request({
    url: `/register/pax/v1`,
    method: "POST",
    data
  });
}

// 代收新增进件
export function addCollectionApiNew(data) {
  return request({
    url: `/register/collection/v1`,
    method: "POST",
    data
  });
}

// 进件编辑
export function editCollectionApiNew(id, data) {
  return request({
    url: `/register/${id}/v1`,
    method: "PUT",
    data
  });
}

// 查询州/省列表
export function getStatesApi(country_code = 'US') {
  return request({
    url: "/region/states/v1",
    method: "GET",
    params: { country_code }
  });
}

// 查询城市列表
export function getCitiesApi(state_code) {
  return request({
    url: "/region/cities/v1",
    method: "GET",
    params: { state_code }
  });
}

// 获取默认采购发票/运营地址证明
export function getDefaultPurchaseInvoiceApi() {
  return request({
    url: "/register/default_purchase_invoice/v1",
    method: "GET"
  });
}

